import { HowItWorksPage as HowItWorksComponent } from '../components/HowItWorksPage';
import { useNavigate } from 'react-router-dom';

export function HowItWorksPage() {
  const navigate = useNavigate();

  const handleNavigateHome = () => {
    navigate('/');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <HowItWorksComponent onNavigateHome={handleNavigateHome} />
  );
}
